import { INavBar } from '../app/Components/navbar/navbar.model';
import { BacAboutComponent } from '../app/Pages/Bac/bac-about/bac-about.component';
import { BacHistoryComponent } from '../app/Pages/Bac/bac-about/bac-history/bac-history.component';
import { BacStaffComponent } from '../app/Pages/Bac/bac-about/bac-staff/bac-staff.component';
import { BacTourComponent } from '../app/Pages/Bac/bac-about/bac-tour/bac-tour.component';
import { BacAcademicsComponent } from '../app/Pages/Bac/bac-academics/bac-academics.component';
import { BacCollegeComponent } from '../app/Pages/Bac/bac-academics/bac-stages/bac-college/bac-college.component';
import { BacElementaryComponent } from '../app/Pages/Bac/bac-academics/bac-stages/bac-elementary/bac-elementary.component';
import { BacLyceeComponent } from '../app/Pages/Bac/bac-academics/bac-stages/bac-lycee/bac-lycee.component';
import { BacActivitiesComponent } from '../app/Pages/Bac/bac-activities/bac-activities.component';
import { BacArtComponent } from '../app/Pages/Bac/bac-activities/bac-art/bac-art.component';
import { BacSportComponent } from '../app/Pages/Bac/bac-activities/bac-sport/bac-sport.component';
import { BacTheatreComponent } from '../app/Pages/Bac/bac-activities/bac-theatre/bac-theatre.component';
import { BacAdmissionComponent } from '../app/Pages/Bac/bac-admission/bac-admission.component';
import { BacAlumniComponent } from '../app/Pages/Bac/bac-alumni/bac-alumni.component';
import { BacCareersComponent } from '../app/Pages/Bac/bac-careers/bac-careers.component';
import { BacHomeComponent } from '../app/Pages/Bac/bac-home/bac-home.component';
import { BacLibraryComponent } from '../app/Pages/Bac/bac-library/bac-library.component';
import { BacMediaComponent } from '../app/Pages/Bac/bac-media/bac-media.component';
import { BacPhotoComponent } from '../app/Pages/Bac/bac-media/bac-photo/bac-photo.component';
import { BacPressComponent } from '../app/Pages/Bac/bac-media/bac-press/bac-press.component';
import { BacRadioComponent } from '../app/Pages/Bac/bac-media/bac-radio/bac-radio.component';
import { BacVideoComponent } from '../app/Pages/Bac/bac-media/bac-video/bac-video.component';
import { BacNewsComponent } from '../app/Pages/Bac/bac-news/bac-news.component';
import { NotfoundComponent } from '../app/Pages/notfound/notfound.component';
import { Routes } from '@angular/router';

export const bacConfigs = {
  routes: [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: BacHomeComponent },
    {
      path: 'academics',
      children: [
        { path: '', component: BacAcademicsComponent },
        {
          path: 'stages',
          children: [
            { path: 'elementary', component: BacElementaryComponent },
            { path: 'college', component: BacCollegeComponent },
            { path: 'lycee', component: BacLyceeComponent },
          ],
        },
        { path: 'library', component: BacLibraryComponent },
      ],
    },
    { path: 'news', component: BacNewsComponent },
    {
      path: 'activities',
      children: [
        { path: '', component: BacActivitiesComponent },
        { path: 'art', component: BacArtComponent },
        { path: 'sports', component: BacSportComponent },
        { path: 'theatre', component: BacTheatreComponent },
      ],
    },
    {
      path: 'mediacenter',
      children: [
        { path: '', component: BacMediaComponent },
        // { path: 'photo', component: BacPhotoComponent },
        // { path: 'video', component: BacVideoComponent },
        { path: 'press', component: BacPressComponent },
        { path: 'radio', component: BacRadioComponent },
      ],
    },
    { path: 'alumni', component: BacAlumniComponent },
    {
      path: 'about',
      children: [
        { path: '', component: BacAboutComponent },
        { path: 'history', component: BacHistoryComponent },
        { path: 'tour', component: BacTourComponent },
        { path: 'staff', component: BacStaffComponent },
      ],
    },
    { path: 'admission', component: BacAdmissionComponent },
    { path: 'careers', component: BacCareersComponent },
    { path: '**', component: NotfoundComponent },
  ] as Routes,

  systemLogos: ['bac_logo.png'],

  navbar: [
    { title: 'home', url: '/home' },
    {
      title: 'academics',
      url: '/academics',
      children: [
        {
          title: 'stages',
          url: '/academics',
          fragment: 'STAGES_SECTION',
        },
        {
          title: 'libraries',
          url: '/academics',
          fragment: 'LIBRARY_SECTION',
        },
      ],
    },
    { title: 'news', url: '/news' },
    {
      title: 'activities',
      url: '/activities',
      children: [
        {
          title: 'art',
          url: '/activities/art',
        },
        {
          title: 'sport',
          url: '/activities/sports',
        },
        {
          title: 'theatre',
          url: '/activities/theatre',
        },
      ],
    },
    {
      title: 'media_center',
      url: '/mediacenter',
      children: [
        // {
        //   title: 'photo_gallery',
        //   url: '/mediacenter/photo',
        // },
        // {
        //   title: 'video_gallery',
        //   url: '/mediacenter/video',
        // },
        {
          title: 'press_release',
          url: '/mediacenter/press',
        },
        {
          title: 'radio',
          url: '/mediacenter/radio',
        },
      ],
    },
    { title: 'alumni', url: '/alumni' },
    {
      title: 'about_us',
      url: '/about',
      children: [
        {
          title: 'history',
          url: '/about/history',
        },
        {
          title: 'school_tour',
          url: '/about/tour',
        },
        {
          title: 'staff',
          url: '/about/staff',
        },
      ],
    },
    { title: 'admission', url: '/admission' },
    { title: 'careers', url: '/careers' },
  ] as INavBar[],
};
